import { render, staticRenderFns } from "./dzswjytj.vue?vue&type=template&id=5a94ae35&scoped=true"
import script from "./dzswjytj.vue?vue&type=script&lang=js"
export * from "./dzswjytj.vue?vue&type=script&lang=js"
import style0 from "./dzswjytj.vue?vue&type=style&index=0&id=5a94ae35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a94ae35",
  null
  
)

export default component.exports